import { NameValue } from '../models/name-value';

export const TRAVEL_STATUSES: NameValue[] = [
    { name: 'First Mile', value: 'First Mile' },
    { name: 'In Transit', value: 'In Transit' },
    { name: 'Last Mile', value: 'Last Mile' }
];
